import { getClosestConfigurationFromRow } from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/getClosestConfiguration';
import calculateMatrixAxis from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/calculateMatrixAxis';

function compileRowTranslation(row) {
    if (row.transformation.translation.manual) {
        return row;
    }

    const { seatConfig } = getClosestConfigurationFromRow(row, 'seatConfig');
    const { spacing } = getClosestConfigurationFromRow(row, 'spacing');

    row.transformation = {
        ...row.transformation,
        translation: {
            ...row.transformation.translation,
            y: calculateMatrixAxis(row.index + 1, seatConfig.size, spacing.h),
            manual: false,
        },
    };

    return row;
}

export default compileRowTranslation;
